import { useReframe } from 'nike-re-framejs';
import { loggedIn$ } from './subs';
import { Set } from 'immutable';
import { LocalizedText } from '../../types/generated/nikeone';

export const lang = getLocale();

export function localize(localizedText: LocalizedText): string {
    if (!localizedText) {
        return '';
    }
    return localizedText[lang];
}

export function localizeMap(localizedText: Map<any, any>): string {
    if (!localizedText) {
        return '';
    }
    return localizedText.get(lang);
}

export function getLocale() {
    return window.OPTIONS.locale || window.OPTIONS.lang;
}

export function parseStatsAsScore(stat: string) {
    const scoreTokens = stat?.split(':') || [];
    const home = Number(scoreTokens[0]) || 0;
    const away = Number(scoreTokens[1]) || 0;
    return { home, away };
}

export const isHalfTime = periodType => periodType === 'HALFTIME_SCORE';

export const LoggedInOnly = function({ children, fallback = null }) {
    const derefSub = useReframe();
    const loggedIn = derefSub(loggedIn$);

    return loggedIn ? children : fallback;
};

export const isNotEmpty = value => value !== null && value !== undefined;

export const setSEO = sportName => {
    const title = sportName ? `${sportName} - ` : '';
    document.title = `${title}Live stávky a výsledky | Niké je tipovanie`;
    document.getElementsByTagName('meta')[
        'description'
    ].content = `${title}Tipujte zápasy live. Prehľadná stávková ponuka, výsledky a štatistiky. Live prenosy a matchradar. Pravidelné promo akcie. Zabávajte sa s Niké.`;
};

export const getLayout = (sportName: string) => sportName?.replace(/-/g, '');

export function makeMatchesRequestParam(sportEventIds = Set(), live = true) {
    return {
        live: live,
        prematch: true,
        results: true,
        sportEventId: sportEventIds.toArray()
    };
}

export function makeTournamentsRequestParam(tournamentsIds = Set()) {
    return {
        top_tournaments: true,
        live: false,
        prematch: true,
        results: false,
        tournamentId: tournamentsIds.toArray()
    };
}

export const matchVisible = (radar: boolean, filterRadar: boolean, video: boolean, filterVideo: boolean) =>
    (radar || !filterRadar) && (video || !filterVideo);

export const sportKey = (sportName: string, key: string) => `${sportName}-${key}`;

export const hasGameScorePlaceholder = (sportId: string | number) => `${sportId}` === '7';
